import { render, staticRenderFns } from "./SelloutTabelaDetalhado.vue?vue&type=template&id=6d3fab1a&lang=html&"
import script from "./SelloutTabelaDetalhado.vue?vue&type=script&lang=js&"
export * from "./SelloutTabelaDetalhado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/sell-out/SelloutTabelaDetalhado.vue
// module id = 1493
// module chunks = 28